import React, { useState } from "react";
import Typist from "react-typist";

const Header = (props) => {
  const [isTyped, setIsTyped] = useState(false);

  const onTypingDone = () => {
    setTimeout(() => {
      setIsTyped(true);
    }, 300);
  };

  if (props.data) {
    var occupation = props.data.occupation;
    var companyName = props.data.companyName;
    var companyUrl = props.data.companyUrl;
    var description = props.data.description;
    var networks = props.data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }

  return (
    <header id="home">
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>

        <ul id="nav" className="nav">
          <li className="current">
            <a className="smoothscroll" href="#home">
              Home
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#about">
              About
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#resume">
              Resume
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#portfolio">
              Works
            </a>
          </li>
          <li>
            <a className="smoothscroll" href="#testimonials">
              Testimonials
            </a>
          </li>
          {/* <li>
              <a className="smoothscroll" href="#contact">
                Contact
              </a>
            </li> */}
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">
            <Typist
              avgTypingDelay={150}
              onTypingDone={onTypingDone}
              cursor={{ show: false }}
            >
              Aizaz Hassan
            </Typist>
          </h1>
          <div className={`desc ${isTyped ? "show" : ""}`}>
            <h3>
              <span>{occupation}&nbsp;</span>
              <a href={companyUrl}>{companyName}</a>
              <span
                dangerouslySetInnerHTML={{
                  __html: `${description}.`,
                }}
              />
            </h3>
            <hr />
            <ul className="social">{networks}</ul>
          </div>
        </div>
      </div>

      <p className="scrolldown">
        <a className="smoothscroll" href="#about">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js